<p-toast/>

<!-- Forgot Password Dialog -->
<p-dialog [(visible)]="showForgotPasswordVisisble" [modal]="true" [draggable]="false" [resizable]="false" [style]="{width: '400px'}" header="Reset Password" [closeOnEscape]="true" styleClass="p-fluid">
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPasswordSubmit()" class="space-y-4 p-4">
        <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
            <div class="relative">
                <i-lucide name="mail" class="absolute left-2 top-2 h-5 w-5 text-gray-400"></i-lucide>
                <input type="email" formControlName="email" class="w-full pl-10 pr-4 py-3 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent" placeholder="Enter your email">
            </div>
            <p *ngIf="forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.hasError('required')" class="mt-1 text-xs text-red-600">Email is required.</p>
            <p *ngIf="forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.hasError('email')" class="mt-1 text-xs text-red-600">Enter a valid email.</p>
        </div>
        <div class="flex justify-end gap-2 mt-4">
            <button type="button" (click)="closeForgotPasswordDialog()" class="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-all">
                Cancel
            </button>
            <button type="submit" [disabled]="loading" class="px-4 py-2 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-lg hover:from-amber-600 hover:to-amber-700 transition-all flex items-center justify-center">
                <span>{{ loading ? 'Sending...' : 'Send Reset Link' }}</span>
                <i-lucide *ngIf="!loading" name="send" class="ml-2 h-4 w-4"></i-lucide>
            </button>
        </div>
    </form>
</p-dialog>

<div class="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto modal-scrollbar">
        <div class="p-8">
            <div class="text-center mb-8">
                <img src="/assets/images/logos/Hector_Group_Logo_Black.jpg" alt="Hector Group Logo" class="w-23 h-23 mx-auto mb-4 rounded-full object-cover" />
                <h2 class="text-2xl font-bold text-gray-900 mb-2">
                    {{ isLogin ? 'Welcome Back' : 'Join Hector Global' }}
                </h2>
                <p class="text-gray-600">
                    {{ isLogin ? 'Access your investment dashboard' : 'Start your investment journey' }}
                </p>
            </div>

            <!-- SIGN IN FORM -->
            <form *ngIf="isLogin" [formGroup]="signInForm" (ngSubmit)="onSignIn()" class="space-y-6">
                <!-- Email -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
            Email Address <span class="text-red-500">*</span>
          </label>
                    <div class="relative">
                        <i-lucide name="mail" class="absolute left-2 top-2 h-5 w-5 text-gray-400"></i-lucide>
                        <input type="email" formControlName="email" class="w-full pl-10 pr-4 py-3 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400" placeholder="your@email.com" />
                    </div>
                    <p *ngIf="signInForm.get('email')?.touched && signInForm.get('email')?.hasError('required')" class="mt-1 text-xs text-red-600">Email is required.</p>
                    <p *ngIf="signInForm.get('email')?.touched && signInForm.get('email')?.hasError('email')" class="mt-1 text-xs text-red-600">Enter a valid email.</p>
                </div>

                <!-- Password -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
            Password <span class="text-red-500">*</span>
          </label>
                    <div class="relative">
                        <i-lucide name="lock" class="absolute left-2 top-2 h-5 w-5 text-gray-400"></i-lucide>
                        <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="w-full pl-10 pr-12 py-3 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400" placeholder="••••••••"
                        />
                        <button type="button" (click)="togglePasswordVisibility()" class="absolute right-3 top-3 text-gray-400 hover:text-gray-600">
              <i-lucide [name]="showPassword ? 'eye-off' : 'eye'" class="h-7 w-5"></i-lucide>
            </button>
                    </div>
                    <p *ngIf="signInForm.get('password')?.touched && signInForm.get('password')?.hasError('required')" class="mt-1 text-xs text-red-600">Password is required.</p>
                </div>

                <div class="flex items-center justify-between mt-4">
                    <div class="flex items-center">
                        <p-checkbox inputId="remember-me" [binary]="true"></p-checkbox>
                        <label for="remember-me" class="ml-2 text-sm text-gray-500">Remember me</label>
                    </div>
                    <a (click)="showForgotPasswordDialog()" class="text-sm font-medium text-amber-600 hover:underline cursor-pointer">
                        Forgot Password?
                    </a>
                </div>

                <!-- Submit Button -->
                <button type="submit" class="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white py-3 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg flex items-center justify-center" [disabled]="loading">
                  {{ loading ? 'Processing...' : 'Sign In' }}
                  <i-lucide *ngIf="!loading" name="arrow-right" class="ml-2 h-5 w-5"></i-lucide>
                </button>
            </form>

            <!-- SIGN UP FORM -->
            <form *ngIf="!isLogin" [formGroup]="signUpForm" (ngSubmit)="onSignUp()" class="space-y-6">

                <!-- First Name and Last Name for Signup -->
                <div class="grid grid-cols-2 gap-4">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
              First Name <span class="text-red-500">*</span>
            </label>
                        <input type="text" formControlName="firstName" appPattern="alphaSpaces"
                               class="w-full px-4 py-3 text-gray-900 bg-white border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400"
                               [ngClass]="signUpForm.get('firstName')?.invalid && signUpForm.get('firstName')?.touched ? 'border-red-500' : 'border-gray-300'"
                               placeholder="John" />
                        <p *ngIf="signUpForm.get('firstName')?.touched && signUpForm.get('firstName')?.hasError('required')" class="mt-1 text-xs text-red-600">First name is required.</p>
                        <p *ngIf="signUpForm.get('firstName')?.touched && signUpForm.get('firstName')?.hasError('minlength')" class="mt-1 text-xs text-red-600">Must be at least 2 characters.</p>
                        <p *ngIf="signUpForm.get('firstName')?.touched && (signUpForm.get('firstName')?.hasError('pattern') || signUpForm.get('firstName')?.hasError('appPattern'))" class="mt-1 text-xs text-red-600">Only alphabets and spaces allowed.</p>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
              Last Name <span class="text-red-500">*</span>
            </label>
                        <input type="text" formControlName="lastName" appPattern="alphaSpaces"
                               class="w-full px-4 py-3 text-gray-900 bg-white border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400"
                               [ngClass]="signUpForm.get('lastName')?.invalid && signUpForm.get('lastName')?.touched ? 'border-red-500' : 'border-gray-300'"
                               placeholder="Doe" />
                        <p *ngIf="signUpForm.get('lastName')?.touched && signUpForm.get('lastName')?.hasError('required')" class="mt-1 text-xs text-red-600">Last name is required.</p>
                        <p *ngIf="signUpForm.get('lastName')?.touched && signUpForm.get('lastName')?.hasError('minlength')" class="mt-1 text-xs text-red-600">Must be at least 2 characters.</p>
                        <p *ngIf="signUpForm.get('lastName')?.touched && (signUpForm.get('lastName')?.hasError('pattern') || signUpForm.get('lastName')?.hasError('appPattern'))" class="mt-1 text-xs text-red-600">Only alphabets and spaces allowed.</p>
                    </div>
                </div>

                <!-- Email -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
            Email Address <span class="text-red-500">*</span>
          </label>
                    <div class="relative">
                        <i-lucide name="mail" class="absolute left-2 top-2 h-5 w-5 text-gray-400"></i-lucide>
                        <input type="email" formControlName="email" class="w-full pl-10 pr-4 py-3 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400" placeholder="your@email.com" />
                    </div>
                    <p *ngIf="signUpForm.get('email')?.touched && signUpForm.get('email')?.hasError('required')" class="mt-1 text-xs text-red-600">Email is required.</p>
                    <p *ngIf="signUpForm.get('email')?.touched && signUpForm.get('email')?.hasError('email')" class="mt-1 text-xs text-red-600">Enter a valid email.</p>
                </div>

                <!-- Phone Number for Signup -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
            Phone Number <span class="text-red-500">*</span>
          </label>
                    <input type="tel" formControlName="phone" appPattern="mobile8to15"
                           class="w-full px-4 py-3 text-gray-900 bg-white border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400"
                           [ngClass]="signUpForm.get('phone')?.invalid && signUpForm.get('phone')?.touched ? 'border-red-500' : 'border-gray-300'"
                           placeholder="971 50 123 4567" />
                    <p *ngIf="signUpForm.get('phone')?.touched && signUpForm.get('phone')?.hasError('required')" class="mt-1 text-xs text-red-600">Phone number is required.</p>
                    <p *ngIf="signUpForm.get('phone')?.touched && signUpForm.get('phone')?.hasError('minlength')" class="mt-1 text-xs text-red-600">Phone number is too short.</p>
                    <p *ngIf="signUpForm.get('phone')?.touched && signUpForm.get('phone')?.hasError('maxlength')" class="mt-1 text-xs text-red-600">Phone number is too long.</p>
                    <p *ngIf="signUpForm.get('phone')?.touched && (signUpForm.get('phone')?.hasError('pattern') || signUpForm.get('phone')?.hasError('appPattern'))" class="mt-1 text-xs text-red-600">Digits only (8–15).</p>
                </div>

                <!-- Password -->
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
            Password <span class="text-red-500">*</span>
          </label>
                    <div class="relative">
                        <i-lucide name="lock" class="absolute left-2 top-2 h-5 w-5 text-gray-400"></i-lucide>
                        <input [type]="showPassword ? 'text' : 'password'" formControlName="password" class="w-full pl-10 pr-12 py-3 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400" placeholder="••••••••"
                        />
                        <button type="button" (click)="togglePasswordVisibility()" class="absolute right-3 top-3 text-gray-400 hover:text-gray-600">
              <i-lucide [name]="showPassword ? 'eye-off' : 'eye'" class="h-7 w-5"></i-lucide>
            </button>
                    </div>
                    <p *ngIf="signUpForm.get('password')?.touched && signUpForm.get('password')?.hasError('required')" class="mt-1 text-xs text-red-600">Password is required.</p>
                    <p *ngIf="signUpForm.get('password')?.touched && signUpForm.get('password')?.hasError('weakPassword')" class="mt-1 text-xs text-red-600">Password must be strong as per the rules below.</p>

                    <!-- Password strength checklist -->
                    <ul *ngIf="signUpForm.get('password')?.value" class="mt-3 space-y-1 text-sm">
                      <li class="flex items-center" [ngClass]="passwordCriteria.length ? 'text-green-600' : 'text-red-600'">
                        <i-lucide [name]="passwordCriteria.length ? 'check-circle' : 'circle-x'" class="h-4 w-4 mr-2"></i-lucide>
                        At least 8 characters
                      </li>
                      <li class="flex items-center" [ngClass]="passwordCriteria.upper ? 'text-green-600' : 'text-red-600'">
                        <i-lucide [name]="passwordCriteria.upper ? 'check-circle' : 'circle-x'" class="h-4 w-4 mr-2"></i-lucide>
                        At least 1 uppercase letter (A-Z)
                      </li>
                      <li class="flex items-center" [ngClass]="passwordCriteria.lower ? 'text-green-600' : 'text-red-600'">
                        <i-lucide [name]="passwordCriteria.lower ? 'check-circle' : 'circle-x'" class="h-4 w-4 mr-2"></i-lucide>
                        At least 1 lowercase letter (a-z)
                      </li>
                      <li class="flex items-center" [ngClass]="passwordCriteria.number ? 'text-green-600' : 'text-red-600'">
                        <i-lucide [name]="passwordCriteria.number ? 'check-circle' : 'circle-x'" class="h-4 w-4 mr-2"></i-lucide>
                        At least 1 number (0-9)
                      </li>
                      <li class="flex items-center" [ngClass]="passwordCriteria.special ? 'text-green-600' : 'text-red-600'">
                        <i-lucide [name]="passwordCriteria.special ? 'check-circle' : 'circle-x'" class="h-4 w-4 mr-2"></i-lucide>
                        At least 1 special character (!#$%&amp; etc.)
                      </li>
                    </ul>
                </div>

                <!-- Confirm Password and Investment Goals for Signup -->
                <div>
                    <div class="mb-6">
                        <label class="block text-sm font-medium text-gray-700 mb-2">
              Confirm Password <span class="text-red-500">*</span>
            </label>
                        <div class="relative">
                            <i-lucide name="lock" class="absolute left-2 top-2 h-5 w-5 text-gray-400"></i-lucide>
                            <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" class="w-full pl-10 pr-12 py-3 text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent placeholder-gray-400"
                                placeholder="••••••••" (paste)="onConfirmPasswordPaste($event)" />
                            <button type="button" (click)="toggleConfirmPasswordVisibility()" class="absolute right-3 top-3 text-gray-400 hover:text-gray-600">
                              <i-lucide [name]="showConfirmPassword ? 'eye-off' : 'eye'" class="h-7 w-5"></i-lucide>
                            </button>
                        </div>
                        <p *ngIf="signUpForm.get('confirmPassword')?.touched && signUpForm.get('confirmPassword')?.hasError('required')" class="mt-1 text-xs text-red-600">Confirm password is required.</p>
                        <p *ngIf="signUpForm.get('confirmPassword')?.touched && signUpForm.get('confirmPassword')?.hasError('mismatch')" class="mt-1 text-xs text-red-600">Passwords do not match.</p>
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">
              Investment Goals <span class="text-red-500">*</span>
            </label>
                        <p-select formControlName="investmentGoals" [options]="investmentGoalOptions" optionLabel="label" optionValue="value" placeholder="Select your investment focus" class="w-full"></p-select>
                        <p *ngIf="signUpForm.get('investmentGoals')?.touched && signUpForm.get('investmentGoals')?.hasError('required')" class="mt-1 text-xs text-red-600">Please select an investment goal.</p>
                    </div>
                </div>

                <!-- Submit Button -->
                <button type="submit" class="w-full bg-gradient-to-r from-amber-500 to-amber-600 text-white py-3 rounded-lg font-semibold hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg flex items-center justify-center" [disabled]="loading">
          {{ loading ? 'Processing...' : 'Create Account' }}
          <i-lucide *ngIf="!loading" name="arrow-right" class="ml-2 h-5 w-5"></i-lucide>
        </button>
            </form>

            <!-- Toggle Auth Mode -->
            <div class="mt-6 text-center">
                <button (click)="toggleAuthMode()" class="text-amber-600 hover:text-amber-700 font-medium">
          {{ isLogin ? "Don't have an account? Sign up" : "Already have an account? Sign in" }}
        </button>
            </div>

            <!-- Security Notice -->
            <!-- <div class="mt-6 pt-6 border-t border-gray-200">
                <div class="flex items-center justify-center text-sm text-gray-500">
                    <i-lucide name="shield" class="h-4 w-4 mr-2"></i-lucide>
                    Secured by 256-bit SSL encryption
                </div>
            </div> -->
        </div>

        <!-- Close Button -->
        <button (click)="closeModal()" class="absolute top-5 right-5 text-gray-400 hover:text-gray-600">
            <i-lucide name="x" class="text-white" ></i-lucide>
    </button>
    </div>
</div>